export const API_BASE =
  process.env.REACT_APP_API_BASE || `http://${window.location.hostname}:8000`;
